import { useMultiplayer } from "../../../context/MultiplayerContext";
import { getOpponent } from "../../../utils/utils";

export default function PlayAgainRequestStatus() {
    const { multiplayerState } = useMultiplayer();

    if (!multiplayerState.playAgainRequest.sentRequest) return null;

    const opponent = getOpponent(multiplayerState);

    if (multiplayerState.playAgainResponse.receivedResponse) {
        const wasAccepted = multiplayerState.playAgainResponse.response === "accept";
        const statusText = wasAccepted ? "accepted " : "declined ";

        return (
            <p>
                {opponent.username} {statusText} your request to play again.
            </p>
        );
    }

    return <p>Waiting for {opponent.username}&apos;s response...</p>;
}
